import _extends from "@babel/runtime-corejs3/helpers/extends";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import React, { useRef, useState, useEffect, useCallback, Fragment } from 'react';
import { getContext } from 'react-recompose';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import classname from 'classnames';
import { colors, positions, sizes, triggerEvents } from "../../../enums";
import { whitelistStyles } from "../hoc";
import AdaptiveTooltipContent from "./adaptive-tooltip-content";
/**
 * Generates the wrapper around the child component and creates the tooltip element.
 * */

export var AdaptiveTooltip = function AdaptiveTooltip(_ref) {
  var children = _ref.children,
      tooltip = _ref.tooltip,
      position = _ref.position,
      isInverted = _ref.isInverted,
      isCompact = _ref.isCompact,
      isInline = _ref.isInline,
      delay = _ref.delay,
      size = _ref.size,
      color = _ref.color,
      boundaryElement = _ref.boundaryElement,
      showOn = _ref.showOn,
      isOpen = _ref.isOpen,
      floatingPointer = _ref.floatingPointer,
      onBlur = _ref.onBlur,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      targetOffset = _ref.targetOffset;
  var timeoutShowTooltip = useRef(null);
  var childrenRef = useRef(null);
  var tooltipRef = useRef(null);

  var _useState = useState(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var handleMouseEnter = function handleMouseEnter(event) {
    if (visible || !childrenRef.current || !tooltip) return;
    timeoutShowTooltip.current = _setTimeout(function () {
      setVisible(true);
      onOpen(event);
    }, delay);
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (timeoutShowTooltip.current) {
      clearTimeout(timeoutShowTooltip.current);
    }

    setVisible(false);
    onClose(event);
    onBlur(event);
  };

  var handleOnClick = function handleOnClick(event) {
    if (visible) {
      onClose(event);
      onBlur(event);
    } else {
      onOpen(event);
    }
  };

  var handleOnBlur = useCallback(function (event) {
    if (isOpen && tooltipRef.current && childrenRef.current && !tooltipRef.current.contains(event.target) && !childrenRef.current.contains(event.target)) {
      onBlur(event);
      onClose(event);
    }
  }, [isOpen, onBlur]);
  useEffect(function () {
    if (showOn === triggerEvents.tooltip.CLICK) {
      setVisible(isOpen);
    }
  }, [isOpen]);
  useEffect(function () {
    if (showOn === triggerEvents.tooltip.CLICK) {
      var body = window.document.body;
      body.addEventListener('click', handleOnBlur);
      body.addEventListener('contextmenu', handleOnBlur);
      return function () {
        body.removeEventListener('click', handleOnBlur);
        body.removeEventListener('contextmenu', handleOnBlur);
      };
    }
  }, [handleOnBlur]);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    className: classname('ck-adaptive-tooltip__children-wrapper', {
      'ck-adaptive-tooltip__children-wrapper--inline': isInline
    })
  }, showOn === triggerEvents.tooltip.HOVER && {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, showOn === triggerEvents.tooltip.CLICK && {
    onClick: handleOnClick
  }, {
    ref: childrenRef
  }), children), tooltip && visible && childrenRef.current ? /*#__PURE__*/React.createElement(AdaptiveTooltipContent, {
    hoveredElementRef: childrenRef.current,
    isInverted: isInverted,
    isCompact: isCompact,
    position: position,
    visible: visible,
    color: color,
    size: size,
    boundaryElement: boundaryElement,
    tooltipRef: tooltipRef,
    targetOffset: targetOffset,
    floatingPointer: floatingPointer
  }, tooltip) : null);
};
AdaptiveTooltip.defaultProps = {
  tooltip: '',
  position: positions.TOP,
  size: sizes.X4,
  color: colors.BASE,
  isInverted: false,
  isCompact: false,
  isInline: true,
  delay: 300,
  boundaryElement: window.document.body.ownerDocument.body,
  showOn: triggerEvents.tooltip.HOVER,
  isOpen: false,
  floatingPointer: false,
  onBlur: noop,
  onOpen: noop,
  onClose: noop,
  targetOffset: 0
};
AdaptiveTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  position: PropTypes.oneOf(positions.ALL),
  isInverted: PropTypes.bool,
  floatingPointer: PropTypes.bool,
  size: PropTypes.oneOf([sizes.X3, sizes.X4, sizes.X5, sizes.X6, sizes.X7, sizes.X8]),
  color: PropTypes.oneOf([colors.BASE, colors.ERROR]),
  delay: PropTypes.number,
  isCompact: PropTypes.bool,
  isInline: PropTypes.bool,
  boundaryElement: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.object]),
  showOn: PropTypes.oneOf(triggerEvents.tooltip.ALL),
  targetOffset: PropTypes.number,
  onBlur: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};
export default whitelistStyles()(getContext({
  isInverted: PropTypes.bool
})(AdaptiveTooltip));
//# sourceMappingURL=adaptive-tooltip.js.map